import React, { useState, useEffect } from "react";
import BudgetRow from "../components/BudgetRow";
import { useSelector } from "react-redux";
import {
  getBudget,
  addBudget,
  updateBudget,
  removeBudget,
} from "../api/budget";
import queryClient from "../utils/query";
import { useQuery } from "react-query";
import { getCategories } from "../api/budget";

export default function BudgetBox({
  type,
  list,
  account,
  title,
  className,
  titleClassName,
  edit,
  income,
  onClick,
}) {
  const dateStore = useSelector((state) => state.date);
  const [items, setItems] = useState(list);
  const [newItem, setNewItem] = useState({});
  const [addedList, setAddedList] = useState([]);

  useEffect(() => {
    setItems(list);
  }, [list]);

  function convertCurrency(number) {
    return new Intl.NumberFormat().format(number);
  }

  function getRate() {
    if (!items || items.length === 0 || !income) return null;

    const amount = items.reduce((accumulator, obj) => {
      return accumulator + obj.AMOUNT;
    }, 0);

    return ((amount / income) * 100).toFixed(1) + "%";
  }

  function handleChangeCategory(e, index) {
    items[index].CATEGORY = e.target.value;
    const result = [...items];
    setItems(result);
  }

  function handleChangeDetail(e, index) {
    items[index].DETAIL = e.target.value;
    const result = [...items];
    setItems(result);
  }

  function handleChangeAmount(e, index) {
    items[index].AMOUNT = e.target.value;
    const result = [...items];
    setItems(result);
  }

  function editAddedListItemCategory(e, index) {
    addedList[index].CATEGORY = e.target.value;
    const result = [...addedList];
    setAddedList(result);
  }

  function editAddedListItem(e, index) {
    addedList[index].DETAIL = e.target.value;
    const result = [...addedList];
    setAddedList(result);
  }

  function editAddedListItemAmount(e, index) {
    addedList[index].AMOUNT = e.target.value;
    const result = [...addedList];
    setAddedList(result);
  }

  async function saveData(budget) {
    const result = await updateBudget(budget);
    console.log(result);
  }

  async function onAdd() {
    if (!newItem.CATEGORY || !newItem.AMOUNT) {
      alert("값을 모두 입력해주세요.");
      return;
    }
    let list = [...addedList];
    list.push(newItem);
    setAddedList(list);
    setNewItem({ CATEGORY: "", AMOUNT: 0 });
  }

  async function onSave() {
    if (addedList.length === 0) {
      alert("추가된 데이터가 없습니다.");
      return;
    }
    const result = await addBudget(addedList.filter((t) => t.DETAIL !== ""));

    if (result.result) {
      await queryClient.invalidateQueries([
        "getBudget",
        dateStore.year,
        dateStore.month,
      ]);
      setItems(
        JSON.parse(localStorage.getItem("budgets")).filter(
          (t) => t.TYPE === type
        )
      );
      setAddedList([]);
    }
  }

  async function deleteData(budget) {
    const result = await removeBudget(budget);

    if (result.result) {
      await queryClient.invalidateQueries([
        "getBudget",
        dateStore.year,
        dateStore.month,
      ]);
      setItems(
        JSON.parse(localStorage.getItem("budgets")).filter(
          (t) => t.TYPE === type
        )
      );
    }
  }

  function prevMonth(year, month) {
    let result = [year, month];
    if (month === 1) {
      result[0] -= 1;
    } else {
      result[1] -= 1;
    }
    return result;
  }

  async function onLoadLastMonth() {
    const prev = prevMonth(dateStore.year, dateStore.month);
    const result = await getBudget(prev[0], prev[1], type);
    result.forEach((x) => {
      x.YEAR = dateStore.year;
      x.MONTH = dateStore.month;
    });
    setAddedList(result);
  }

  const categoryList = useQuery({
    queryKey: "getCategories",
    queryFn: async () => await getCategories(),
  }).data;

  let options = [];
  if (categoryList && categoryList.length > 0) {
    options.push(<option selected>-</option>);
    categoryList
      .filter((t) => t.TYPE === type)
      .forEach((c, i) => {
        options.push(
          <option key={c.ID} value={c.NAME}>
            {c.NAME}
          </option>
        );
      });
  }

  return (
    <div>
      <div className={`h-full p-1 ${className} border rounded`}>
        <div
          className={`font-bold text-center bg-gray-100 p-2 rounded-md text-gray-700 ${titleClassName}`}
        >
          {title} {getRate()}
        </div>
        <div
          className={`grid ${
            edit ? "grid-cols-3" : "grid-cols-4"
          } truncate font-bold`}
        >
          <div>구분</div>
          <div>내용</div>
          <div>금액</div>
          {!edit ? <div>잔액</div> : null}
        </div>
        {items?.map((budget, index) => {
          return (
            <BudgetRow
              item={budget}
              edit={edit}
              balance={
                budget.AMOUNT -
                account
                  ?.filter((t) => t.CATEGORY === budget.CATEGORY && (t.TYPE === 4 ? t.DETAIL === budget.DETAIL : true))
                  ?.reduce((a, b) => a + b.AMOUNT, 0)
              }
              onChange={(e) => handleChangeCategory(e, index)}
              onChangeDetail={(e) => handleChangeDetail(e, index)}
              onChangeAmount={(e) => handleChangeAmount(e, index)}
              onSave={() => saveData(budget)}
              onRemove={() => deleteData(budget)}
            />
          );
        })}
        <div className="w-full h-0.5 border-t border-dashed border-gray-400 my-2"></div>
        {edit ? (
          <div className="flex justify-between items-center">
            <select
              className="h-6 border border-gray-600 rounded"
              value={newItem.CATEGORY}
              onChange={(e) =>
                setNewItem({
                  YEAR: dateStore.year,
                  MONTH: dateStore.month,
                  TYPE: newItem.TYPE,
                  CATEGORY: e.target.value,
                  DETAIL: newItem.DETAIL,
                  AMOUNT: newItem.AMOUNT,
                })
              }
            >
              {options}
            </select>
            <input
              type="text"
              value={newItem.DETAIL}
              onChange={(e) =>
                setNewItem({
                  YEAR: dateStore.year,
                  MONTH: dateStore.month,
                  TYPE: type,
                  CATEGORY: newItem.CATEGORY,
                  DETAIL: e.target.value,
                  AMOUNT: newItem.AMOUNT,
                })
              }
            />
            <div class="flex items-center">
              <input
                type="number"
                className="sm:w-20"
                value={newItem.AMOUNT}
                onChange={(e) =>
                  setNewItem({
                    YEAR: dateStore.year,
                    MONTH: dateStore.month,
                    TYPE: type,
                    CATEGORY: newItem.CATEGORY,
                    DETAIL: newItem.DETAIL,
                    AMOUNT: +e.target.value,
                  })
                }
              />
              <button
                className="flex items-center justify-center w-6 h-6 rounded ml-2 pt-1 bg-lime-600 text-white text-base font-bold"
                onClick={onAdd}
              >
                +
              </button>
            </div>
          </div>
        ) : null}

        {addedList
          ? addedList.map((item, i) => {
              return (
                <div className="flex justify-between items-center">
                  <select
                    className="h-6 border border-gray-600 rounded"
                    value={item.CATEGORY}
                    onChange={(e) => editAddedListItemCategory(e, i)}
                  >
                    {options}
                  </select>
                  <input
                    type="text"
                    className="w-1/2"
                    value={item.DETAIL}
                    onChange={(e) => editAddedListItem(e, i)}
                  />
                  <div class="flex items-center">
                    <input
                      type="number"
                      className="sm:w-20"
                      value={item.AMOUNT}
                      onChange={(e) => editAddedListItemAmount(e, i)}
                    />
                  </div>
                </div>
              );
            })
          : null}
        {addedList && edit ? (
          <button
            class="w-full border-lime-500 my-2 bg-lime-50 border rounded"
            onClick={onSave}
          >
            SAVE
          </button>
        ) : null}

        {edit ? (
          <button
            class="w-full border-lime-500 bg-lime-50 border rounded"
            onClick={onLoadLastMonth}
          >
            저번 달 데이터 불러오기
          </button>
        ) : null}
        <div className="pt-3 grid grid-cols-4">
          <span className="col-span-2">합계</span>
          <span className="col-span-2">
            {convertCurrency(
              items?.reduce((accumulator, obj) => {
                return accumulator + obj.AMOUNT;
              }, 0)
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
